<!-- ============ NAVBAR ============ -->
<header class="site-header">
  <nav class="navbar navbar-expand-lg main-navbar">
    <div class="container-fluid px-3 px-lg-4">
      <a class="navbar-brand d-flex align-items-center gap-2" routerLink="/">
        <img src="assets/images/logo.png" alt="UMYO Español" class="brand-logo" onerror="this.style.display='none'">
        <span class="brand-text">
          UMYO <span class="text-pink">ESPAÑOL</span>
          <small>DIRECTORY</small>
          <span class="tagline">FOR US. BY US. — POWERED BY UMYO.</span>
        </span>
      </a>

      <button class="menu-btn d-flex d-md-none navbar-toggler"
        type="button"
        (click)="isNavOpen = !isNavOpen"
        [attr.aria-expanded]="isNavOpen"
        aria-controls="navbarNav"
        aria-label="Toggle navigation"
      >
        <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
          <path d="M3 6h18M3 12h18M3 18h18"/>
        </svg>
      </button>

      <div class="navbar-collapse justify-content-center" id="navbarNav" [class.show]="isNavOpen">
        <ul class="navbar-nav main-nav">
          <li class="nav-item"><a class="nav-link" routerLink="/" (click)="isNavOpen = false">Home</a></li>
          <li class="nav-item"><a class="nav-link" routerLink="/directory" (click)="isNavOpen = false">Directory</a></li>
          <li class="nav-item"><a class="nav-link " routerLink="/packages" (click)="isNavOpen = false">Packages</a></li>
          <li class="nav-item"><a class="nav-link" href="/assets/creat-card/index.html" target="_self">Creat Card</a></li>
          <li class="nav-item"><a class="nav-link" routerLink="/hardship" (click)="isNavOpen = false">Hardship Incentives</a></li>
        </ul>
      </div>

      <div class="d-none d-md-flex align-items-center gap-2">
        <div class="lang-switch">
          <button type="button" class="lang-btn" [class.active]="lang === 'en'" (click)="setLang('en')">EN</button>
          <button type="button" class="lang-btn" [class.active]="lang === 'es'" (click)="setLang('es')">ES</button>
        </div>

        <a href="/?authTab=login#login" class="btn btn-outline-pink btn-sm-pad">{{ t.nav.login }}</a>
        <a href="/?authTab=register#register" class="btn btn-pink">{{ t.nav.register }}</a>
      </div>
    </div>
  </nav>
</header>

<!-- ============ HERO ============ -->
<section class="tc-hero">
  <div class="container" style="position:relative;z-index:1;">
    <span class="hs-eyebrow">{{ t.hero.eyebrow }}</span>
    <h1 class="tc-hero-title">
      {{ t.hero.title }}<br>
      <span class="text-pink">{{ t.hero.titleHighlight }}</span>
    </h1>
    <p class="tc-hero-subtitle">{{ t.hero.subtitle }}</p>
  </div>
</section>

<!-- ============ PRIVACY CONTENT ============ -->
<main class="tc-body">
  <div class="container">
    <div class="tc-wrap">

      <span class="tc-meta">{{ t.meta }}</span>

      <!-- DYNAMIC SECTIONS -->
      <div class="tc-card" *ngFor="let section of t.sections">
        <div class="tc-num">{{ section.num }}</div>
        <h2 class="tc-title">{{ section.title }}</h2>

        <!-- Description -->
        <p *ngIf="section.desc" [innerHTML]="section.desc"></p>

        <!-- Points (with HTML) -->
        <p *ngFor="let point of section.points" [innerHTML]="point"></p>

        <!-- List -->
        <ul class="tc-list" *ngIf="section.list">
          <li *ngFor="let item of section.list">{{ item }}</li>
        </ul>

        <!-- Note -->
        <p *ngIf="section.note" [innerHTML]="section.note"></p>

        <!-- Highlight -->
        <div class="tc-highlight" *ngIf="section.highlight">
          {{ section.highlight }}
        </div>
      </div>

    </div>
  </div>
</main>

<!-- ============ FOOTER ============ -->
<footer class="site-footer pkg-footer">
  <div class="container-fluid px-3 px-lg-4">
    <div class="row py-5">

      <div class="col-lg-3 col-md-6 mb-4 mb-lg-0">
        <div class="d-flex align-items-center gap-2 mb-2">
          <img src="assets/images/logo.png" alt="UMYO Español" class="brand-logo" onerror="this.style.display='none'">
          <div class="brand-text">UMYO <span class="text-pink">ESPAÑOL</span></div>
        </div>
        <small class="d-block pkg-footer-muted">{{ t.footer.tagline }}</small>
      </div>

      <div class="col-lg-3 col-md-6 mb-4 mb-lg-0">
        <h6 class="pkg-footer-heading">{{ t.footer.quickLinks }}</h6>
        <ul class="pkg-footer-links">
          <li><a routerLink="/">Home</a></li>
          <li><a routerLink="/directory">Directory</a></li>
          <li><a routerLink="/packages">Packages</a></li>
          <li><a routerLink="/hardship">Incentives</a></li>
        </ul>
      </div>

      <div class="col-lg-3 col-md-6 mb-4 mb-lg-0">
        <h6 class="pkg-footer-heading">{{ t.footer.resources }}</h6>
        <ul class="pkg-footer-links">
          <li><a routerLink="/services">Services</a></li>
          <li><a routerLink="#">How To</a></li>
          <li><a routerLink="/hardship">Hardship Incentives</a></li>
          <li><a href="/privacy">Privacy Policy</a></li>
          <li><a href="/terms">Terms of Service</a></li>
        </ul>
      </div>

      <div class="col-lg-3 col-md-6">
        <h6 class="pkg-footer-heading">{{ t.footer.connect }}</h6>
        <div class="social-icons justify-content-start">
          <a href="#" aria-label="Instagram">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/>
            </svg>
          </a>
          <a href="#" aria-label="TikTok">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M14 3v11.5a3.5 3.5 0 1 1-3-3.46"/><path d="M14 3c.4 2.6 2.2 4.4 5 4.8"/>
            </svg>
          </a>
          <a href="#" aria-label="YouTube">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <rect x="2" y="5" width="20" height="14" rx="4"/><path d="M10 9l6 3-6 3V9Z" fill="currentColor" stroke="none"/>
            </svg>
          </a>
          <a href="#" aria-label="Facebook">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3Z"/>
            </svg>
          </a>
          <a href="#" aria-label="X">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M4 4l16 16M20 4 4 20"/>
            </svg>
          </a>
        </div>
      </div>

    </div>

    <div class="pkg-footer-bottom text-center py-3">
      <small>{{ t.footer.copyright }}</small>
    </div>
  </div>
</footer>